import {FC, MouseEventHandler} from 'react'

import {TrashIcon} from '@/components/common/icons/TrashIcon'
import {useCommonContent} from '@/content/common'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

import {IconTooltip} from '../tooltip/IconTooltip'

type FormRemoveButtonProps = {
  onRemove: MouseEventHandler<HTMLButtonElement>
}

export const FormRemoveButton: FC<React.PropsWithChildren<FormRemoveButtonProps>> = ({
  onRemove,
}) => {
  const {t} = useTranslation()
  const {removeButton} = useCommonContent()

  return (
    <>
      <IconTooltip tooltipText={t(removeButton)}>
        <button onClick={onRemove} className="button" type="button">
          <TrashIcon />
        </button>
      </IconTooltip>

      <style jsx>{`
        .button {
          padding: ${theme.spacing[2]};
          margin: -${theme.spacing[2]};
        }
      `}</style>
    </>
  )
}
